<template>
  <div>
    <el-container>
      <el-aside
        width="240px"
        style="
          padding-right: 10px;
          overflow: auto;
          background: #fff;
          border-radius: 4px;
        "
      >
        <div class="title-add">
          <div style="margin-left: 10px">部门</div>
        </div>
        <tree ref="trees" @setId="setIds" value="dept"></tree>
      </el-aside>
      <el-main style="margin-top: -20px; padding-bottom: 0px">
        <el-card class="box-card">
          <el-row v-auth="'/deptMgt/addDepartment'">
            <el-col :span="12">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addFormVisible = true"
                >添加部门</el-button
              >
            </el-col>
          </el-row>

          <el-row>
            <el-table style="margin-top: 20px; width: 100%" border :data="list">
              <el-table-column
                label="上级部门"
                prop="pname"
                style="coloe: #4d94ff"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <!-- <span class="operItem" @click="editFormEvent(scope.row,1)">{{scope.row.pname}}</span> -->
                  <span class="operItem">{{ scope.row.pname }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="部门名称"
                prop="name"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="排序"
                prop="sort"
                width="100"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="部门电话"
                prop="phone"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="备注"
                prop="remark"
                width="300"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="状态"
                prop="state"
                width="100"
              >
                <template slot-scope="scope">
                  <div v-auth="'/deptMgt/enableDisable'">
                    <span class="operItem" v-if="scope.row.state == 1"
                      >启用</span
                    >
                    <span class="operItem" v-else>禁用</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="state" width="100">
                <template slot-scope="scope">
                  <span
                    class="operItem"
                    @click="editFormEvent(scope.row, 2)"
                    v-auth="'/deptMgt/updateDepartment'"
                    >编辑</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>
      </el-main>
    </el-container>

    <!------------------------------------------ 添加 ------------------------------------------->
    <el-dialog title="添加部门" :visible.sync="addFormVisible" width="500px">
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="80px"
        :rules="addRules"
      >
        <el-form-item label="上级部门" prop="pid">
          <!-- <el-select v-model="addForm.pid" placeholder="请选择">

            <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>-->
          <el-input
            v-if="addsty"
            disabled
            placeholder="请输入上级部门"
            v-model="names"
          ></el-input>
          <el-cascader
            style="width: 100%"
            clearable
            v-if="!addsty"
            v-model="addForm.pid"
            @change="subjectSearchChange"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请输入上级部门"
            :options="pList"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input v-model.number="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort">
          <el-input v-model.number="addForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="部门电话" prop="phone">
          <el-input
            v-model.number="addForm.phone"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="addForm.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-radio-group v-model="addForm.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('addForm')">重 置</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!------------------------------------------ 编辑 ------------------------------------------->
    <el-dialog title="编辑部门" :visible.sync="editFormVisible" width="500px">
      <el-form
        ref="editForm"
        :model="editForm"
        label-width="80px"
        :rules="addRules"
      >
        <el-form-item label="上级部门" prop="pid">
          <!-- <el-select v-model="editForm.pid" placeholder="请选择">
            <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>

          </el-select>-->
          <el-cascader
            style="width: 100%"
            clearable
            v-model="editForm.pid"
            @change="subjectSearchChanges"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请输入上级部门"
            :options="pList"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input v-model.number="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort">
          <el-input v-model.number="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="部门电话" prop="phone" v-if="editStyle == 2">
          <el-input
            v-model.number="editForm.phone"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark" v-if="editStyle == 2">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state" v-if="editStyle == 2">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('editForm')">重 置</el-button>
        <el-button type="primary" @click="updateDepartment">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tree from "../conmom/tree";

export default {
  components: { tree },
  data () {
    return {
      temporaryPid: '',
      editStyle: null,
      disabled: false,
      pos: 1,

      editForm: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true
      },
      index: 0,
      span: [],
      pList: [],
      searchParam: {
        pageNumber: 1,
        pageSize: 10
      },
      addFormVisible: false,
      addsty: false,
      editFormVisible: false,
      list: [{}],
      names: "",
      addForm: {
        pid: "",
        name: "",
        phone: "",
        sort: "",
        remark: "",
        state: 1
      },
      addRules: {
        phone: [
          { required: true, message: "请输入部门电话", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确"
          }
        ],
        pid: [{ required: true, message: "请选择上级部门", trigger: "change" }],
        name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入显示排序", trigger: "blur" },
          { type: "number", message: "显示排序必须为数字" }
        ]
      }
    };
  },
  methods: {
    setIds (val) {
      console.log(val)
      this.addForm.pid = val[0].id;
      this.names = val[0].name;
      this.addsty = true;
      this.api.department
        .getDepartmentListByTreeId({
          id: String(val[0].id)
        })
        .then(res => {
          if (res.success) {

            res.data.forEach(item => {
              item.pname = val[0].name;
            });
            this.list = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    subjectSearchChange () {
      if (this.addForm.pid) {
        this.addForm.pid = this.addForm.pid[this.addForm.pid.length - 1];
      } else {
        this.addForm.pid = "";
      }

    },
    subjectSearchChanges () {
      if (this.editForm.pid) {
        this.editForm.pid = this.editForm.pid[this.editForm.pid.length - 1];
      } else {
        this.editForm.pid = "";
      }

    },
    editFormEvent (row, style) {
      console.log(row)
      this.editStyle = style;
      if (style == 1) {
        this.editForm = {
          pid: "0",
          id: row.pid,
          name: row.pname,
          sort: row.sort
        };
        this.temporaryPid = row.pid;
      } else {
        this.editForm = row;
      }

      this.editFormVisible = true;
    },

    updateDepartment () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.department.updateDepartment(this.editForm).then(res => {
            if (res.success) {
              this.setIds([{
                id: this.temporaryPid,
                name: this.editForm.pname
              }]);
              this.editFormVisible = false;
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    departmentTreeList () {
      // this.api.department.getDepartmentFirst().then(res => {
      //   this.pList = res.data;
      // });
      this.api.department.getNewDepartmentTreeList().then(result => {
        if (result.success) {
          this.pList = result.data;

        } else {
          this.$message.error(result.message);
        }
      });
    },
    submitAdd () {
      if (this.addForm.pid == 0) {
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.department.addDepartment(this.addForm).then(res => {
            if (res.success) {
              this.addFormVisible = false;
              this.$refs.trees.getSubjectTreeList();
              this.getList();
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    // getList() {
    //   this.api.department.tableList().then(res => {
    //     if (res.success) {
    //       this.list = res.data;
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   });
    // },
    //重置表格
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  },
  watch: {
    addsty: function (newVal) {
      if (!newVal) {
        this.name = "";
      } else {
      }
    },
    addFormVisible: function (newVal) {

      if (!newVal) {
        this.$refs.addForm.resetFields();

        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.editStyle = null;
      } else {
      }
    },
    "addForm.pid": function (newVal) {
      if (newVal == 0) {
        this.disabled = true;
        this.addForm.phone = "";
        this.addForm.remark = "";
        this.addRules = {
          pid: [
            { required: true, message: "请选择上级部门", trigger: "change" }
          ],
          name: [
            { required: true, message: "请输入部门名称", trigger: "blur" }
          ],
          sort: [
            { required: true, message: "请输入显示排序", trigger: "blur" },
            { type: "number", message: "显示排序必须为数字" }
          ]
        };
      } else {
        this.disabled = false;
        this.addRules = {
          pid: [
            { required: true, message: "请选择上级部门", trigger: "change" }
          ],
          name: [
            { required: true, message: "请输入部门名称", trigger: "blur" }
          ],
          sort: [
            { required: true, message: "请输入显示排序", trigger: "blur" },
            { type: "number", message: "显示排序必须为数字" }
          ]
        };
      }
    }
  },
  mounted () {
    this.setIds([
      {
        id: 0,
        name: ""
      }
    ]);
    this.departmentTreeList();
  }
};
</script>
<style lang="less" scoped>
.title-add {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  color: #455a64;
  div {
    font-size: 14px;
    i {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deptMgt/deptMgt.vue